<template>
  <sea-page title="Documenti azienda">
    <home-widget
      title="Aziende"
      icon="mdi-domain"
      :bgColor="colors.primarycolor"
      dark
      :closeButton="false"
      width="100%"
    >
      <div class="d-flex justify-space-between align-center px-3">
        <div class="d-flex justify-start mb-1">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :color="colors.primarycolor"
                x-small
                fab
                dark
                @click="selectAll()"
                class="mr-3"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark>checklist</v-icon>
              </v-btn>
            </template>
            <span>Seleziona tutti</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                :color="colors.primarycolor"
                x-small
                fab
                :dark="selected.length > 0"
                :disabled="selected.length === 0"
                @click="gotoMultiDocuments()"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon dark> mdi-eye </v-icon>
              </v-btn>
            </template>
            <span>Multi azienda</span>
          </v-tooltip>
        </div>
        <div style="width: 400px">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Ricerca rapida"
            single-line
            hide-details
            @click:append="load"
          ></v-text-field>
        </div>
      </div>
      <v-data-table
        v-model="selected"
        :loading="dataLoading"
        loading-text="Attendere"
        :headers="headers"
        :footer-props="footerProps"
        :items="items"
        sort-by="ragioneSociale"
        dense
        :items-per-page="-1"
        show-select
        height="calc(100vh - 260px)"
        hide-default-header
      >
        <template v-slot:header.data-table-select> </template>
        <template v-slot:item.c1="{ item }">
          <v-row no-gutters class="mb-2" align-content="end">
            <v-col cols="12">
              <div class="title">{{ item.ragioneSociale }} {{ item.nome }}</div>
            </v-col>
            <v-col cols="3">
              <div class="text-truncate text-little">
                Partita iva: {{ item.partitaIva }} <br />
                CF: {{ item.codiceFiscale }}
              </div>
            </v-col>
            <v-col cols="3">
              <div class="text-truncate text-caption font-weight-bold">
                Documenti e richieste
              </div>
              <div class="text-truncate text-caption">
                Da pubblicare {{ item.docDaPubblicare }} | Nuovi
                {{ item.docNuovi }}
              </div>
            </v-col>
          </v-row>
        </template>
        <template v-slot:item.c2="{ item }">
          <v-btn
            :color="colors.primarycolor"
            x-small
            fab
            dark
            :disabled="selected.length > 0"
            @click="gotoDocumentsCompany(item.codiceFiscale)"
          >
            <v-icon dark> mdi-eye </v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </home-widget>
  </sea-page>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import HomeWidget from "../../components/Widgets/Widget.vue";
import mixin from "@/mixin";

const headers = [
  { value: "c1", fileterable: false, sortable: false },
  { value: "c2", fileterable: false, sortable: false },
];
const footerProps = {
  itemsPerPageAllText: "Tutte",
  itemsPerPageText: "Righe per pagina",
};

export default {
  name: "Companies",
  mixins: [mixin],
  components: {
    HomeWidget,
  },
  mounted() {
    this.fetchCompany().then(() => (this.dataLoading = false));
  },
  data() {
    return {
      selected: [],
      headers,
      footerProps,
      search: null,
      dataLoading: true,
    };
  },
  methods: {
    selectAll() {
      if (this.selected.length === this.items.length) {
        this.selected = [];
      } else {
        this.selected = [];
        this.items.forEach((item) => this.selected.push(item));
      }
    },
    ...mapActions({
      fetchCompany: "proxy/fetchListaazidoc",
    }),
    gotoDocumentsCompany(id) {
      this.$router.push({
        path: "/company/documents/azi",
        query: { codiceAzienda: id },
      });
    },
    gotoMultiDocuments() {
      if (this.selected.length === 1) {
        this.$router.push({
          path: "/company/documents/azi",
          query: { codiceAzienda: this.selected[0].codiceFiscale },
        });
      } else {
        this.$router.push({
          path: "/company/documents/multi/azi",
          query: {
            codiceAzienda: this.selected.map((azi) => azi.codiceFiscale),
          },
        });
      }
    },
    load() {
      this.dataLoading = true;
      this.fetchCompany(this.search).then(() => (this.dataLoading = false));
    },
  },
  computed: {
    ...mapGetters({
      items: "proxy/firms",
    }),
  },
};
</script>

<style>

</style>